enum CmsWorkflowType {
  B2B_WORKFLOW = 'B2B_WORKFLOW',
  B2C_WORKFLOW = 'B2C_WORKFLOW',
  CONFERENCE_WORKFLOW = 'CONFERENCE_WORKFLOW'
}
export default CmsWorkflowType;
